// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2zuO3","bigColWidth":"Table_bigColWidth__3l9Sd","biggerColWidth":"Table_biggerColWidth__YZuGH","row":"Table_row__2lS0j","col":"Table_col__2w0Jw"};